import { culture } from '../../utils/intl';

const formatNumberInteger = new Intl.NumberFormat(culture, {
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
}).format;

/**
 * Creates a `Map` with key `<date>-<barrier>` and value an array of all products with a
 * expire date of `date` and barrier with `barrier`
*/
const createProductMap = (products, dates, barriers) => {
	const productMap = new Map();

	dates.forEach((date) => {
		barriers.forEach((barrier, index) => {
			const barrierUpperBound = index < barriers.length - 1
				? barriers[index + 1]
				: Number.MAX_VALUE;

			const productGroup = products
				.filter(p => p.date === date && p.barrier >= barrier && p.barrier < barrierUpperBound)
				.sort((p1, p2) => p1.barrier - p2.barrier);

			if (!productGroup.length) {
				return;
			}

			const mapKey = `${date}-${barrier}`;

			productMap.set(mapKey, productGroup);
		});
	});

	return productMap;
};

const getScaleMax = (isZoom, data) => {
	const { barrierMin = 0, barrierMax = 100, barrierBaseLine = 50 } = data;
	const maxDeviation = Math.max(barrierMax - barrierBaseLine, Math.abs(barrierBaseLine - barrierMin));

	return !isZoom || barrierMax > barrierBaseLine ? barrierBaseLine + maxDeviation : barrierMax;
};

const getScaleMin = (isZoom, data) => {
	const { barrierMin = 0, barrierMax = 100, barrierBaseLine = 50 } = data;
	const maxDeviation = Math.max(barrierMax - barrierBaseLine, Math.abs(barrierBaseLine - barrierMin));

	return !isZoom || barrierMin < barrierBaseLine ? barrierBaseLine - maxDeviation : barrierMin;
};

const payoffTypes = {
	TURBO: 'turbo',
	WARRANT: 'warrant',
};

const productDirectionClassMap = new Map([
	['default', 'is-default'],
	['put', 'is-put'],
	['call', 'is-call'],
	['combined', 'is-combined'],
]);

const getProductDirectionClass = direction => (productDirectionClassMap.has(direction.toLowerCase())
	? productDirectionClassMap.get(direction.toLowerCase())
	: productDirectionClassMap.get('default'));

const getDirectionOfCollection = (products) => {
	if (products.some(e => e.direction.toLowerCase() === 'put')	&& products.some(e => e.direction.toLowerCase() === 'call')) {
		return 'combined';
	}
	if (products.some(e => e.direction.toLowerCase() === 'call')) {
		return 'call';
	}
	if (products.some(e => e.direction.toLowerCase() === 'put')) {
		return 'put';
	}

	return 'default';
};

const backgroundBarZebraClass = isOdd => (isOdd ? 'is-odd' : 'is-even');

export {
	formatNumberInteger,
	createProductMap,
	getProductDirectionClass,
	payoffTypes,
	getDirectionOfCollection,
	getScaleMax,
	getScaleMin,
	backgroundBarZebraClass,
};
